import { reactive } from 'vue';

export const criarPac = () => {
  return reactive({
    id: 0,
    idep: 0,
    ordem: 0,
    codigo: '',
    titulo: '',
    ativo: 'S',
    ckagua: 'N',
    ckfraude: 'N',
    cklux: 'N',
    cktemperaturas: 'N',
    idlogin: 0
  });
};